// Webpack Imports
import * as bootstrap from 'bootstrap';



(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	// Representative filters
	document.addEventListener('DOMContentLoaded', function() {
		var institutionFilter = document.getElementById('institution-filter');
		var jobTitleFilter = document.getElementById('job-title-filter');
		var titleFilter = document.getElementById('title-filter');
		var emailFilter = document.getElementById('email-filter');
		var representatives = document.querySelectorAll('.b-representative__single');
	
		function filterRepresentatives() {
			var selectedInstitution = institutionFilter ? institutionFilter.value : '';
			var selectedJobTitle = jobTitleFilter ? jobTitleFilter.value : '';
			var titleFilterValue = titleFilter ? titleFilter.value.toLowerCase() : '';
			var emailFilterValue = emailFilter ? emailFilter.value.toLowerCase() : '';
	
			representatives.forEach(function(rep) {
				var matchesInstitution = selectedInstitution === '' || rep.getAttribute('data-institution-id') === selectedInstitution;
				var matchesJobTitle = selectedJobTitle === '' || rep.getAttribute('data-job-title') === selectedJobTitle;
				var matchesTitle = rep.querySelector('.rep-name').textContent.toLowerCase().includes(titleFilterValue);
				var matchesEmail = rep.querySelector('.rep-email a').textContent.toLowerCase().includes(emailFilterValue);
	
				rep.style.display = matchesInstitution && matchesJobTitle && matchesTitle && matchesEmail ? 'grid' : 'none';
			});
		}
	
		// Only add event listeners if the element exists
		if (institutionFilter) {
			institutionFilter.addEventListener('change', filterRepresentatives);
		}
		if (jobTitleFilter) {
			jobTitleFilter.addEventListener('change', filterRepresentatives);
		}
		if (titleFilter) {
			titleFilter.addEventListener('input', filterRepresentatives);
		}
		if (emailFilter) {
			emailFilter.addEventListener('input', filterRepresentatives);
		}
	});
	
	// Clear search form
	var clearFormButton = document.getElementById('clearform');
	if (clearFormButton) {
		clearFormButton.addEventListener('click', function() {
			var searchForm = document.getElementById('searchform');
			if (searchForm) {
				searchForm.reset();
			}
		});
	}

})();

